import * as actionTypes from "./actionTypes";
import {
  getCatalogsApi,
  getCatalogFieldsApi,
  enableSystemTableEditorsApi,
  createTableAPI,
  updateTableAPI,
  deleteTableAPI,
  createFieldAPI,
  updateFieldAPI,
  deleteFieldAPI,
  updateFieldOptionAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
      errorString = getLocalizedString("validationError");
      break;
    case "IN_USE":
      errorString = getLocalizedString("cannotDisableEditorCreationForSelectedSystemTableBecauseEditorsExist");
      break;
    case "DUPLICATED_DATA":
      errorString = getLocalizedString("cannotExistMoreThanOneTableWithSameCodeOrName");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getCatalogsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getCatalogsApi();
    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: { data },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};


export const createTableAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_TABLE });
  try {
    let response = await createTableAPI(dataToSend);
    let data = response.data && response.data.data;

    dispatch({ type: actionTypes.CREATE_TABLE_FULFILLED, payload: { data } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("tableCreatedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_TABLE_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e;
  }
};

export const modifyTableAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY_TABLE });
  try {
    let response = await updateTableAPI(dataToSend);
    let data = response.data && response.data.data;

    dispatch({ type: actionTypes.MODIFY_TABLE_FULFILLED, payload: { data } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("tableEditedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.MODIFY_TABLE_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e;
  }
};

export const deleteTableAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_TABLE });
  try {
    let response = await deleteTableAPI(dataToSend);
    let data = response.data && response.data.data;

    dispatch({ type: actionTypes.DELETE_TABLE_FULFILLED, payload: { data } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("tableDeletedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_TABLE_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e;
  }
};

export const createFieldAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_FIELD });
  try {
    let response = await createFieldAPI(dataToSend);
    let data = response.data && response.data.data;

    dispatch({ type: actionTypes.CREATE_FIELD_FULFILLED, payload: { data } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("fieldCreatedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_FIELD_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e;
  }
};

export const modifyFieldAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY_FIELD });
  try {
    let response = await updateFieldAPI(dataToSend);
    let data = response.data && response.data.data;

    dispatch({ type: actionTypes.MODIFY_FIELD_FULFILLED, payload: { data } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("fieldEditedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.MODIFY_FIELD_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e;
  }
};
export const modifyFieldOptionAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY_FIELD_OPTION });
  try {
    let response = await updateFieldOptionAPI(dataToSend);
    let data = response.data && response.data.data;

    dispatch({ type: actionTypes.MODIFY_FIELD_OPTION_FULFILLED, payload: { data } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("fieldEditedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.MODIFY_FIELD_OPTION_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e;
  }
};

export const deleteFieldAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_FIELD });
  try {
    let response = await deleteFieldAPI(dataToSend);
    let data = response.data && response.data.data;

    dispatch({ type: actionTypes.DELETE_FIELD_FULFILLED, payload: { data } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("fieldDeletedOK"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_FIELD_REJECTED, payload: e });
    errorHandler(e, dispatch);
    return e;
  }
};

export const getCatalogFieldsAction = (code) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_FIELDS });
  try {
    let response = await getCatalogFieldsApi(`?code=${code}`);
    let data = response.data && response.data.data;
    let status = response.data && response.data.status;
    let typeList = response.data && response.data.typeList;
    let subTypeList = response.data && response.data.subTypeList;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_FIELDS_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FIELDS_FULFILLED,
      payload: { data, typeList, subTypeList },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_FIELDS_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const enableSystemTableEditorsAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE });
  try {
    let response = await enableSystemTableEditorsApi(dataToSend);
    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.UPDATE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.UPDATE_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("updateCompletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.UPDATE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};